import React, { useState } from 'react';
import { Database, RefreshCw } from 'lucide-react';
import { setupInitialData } from '../../utils/setupInitialData';
import { toast } from 'react-hot-toast';

export function SetupDatabase() {
  const [isLoading, setIsLoading] = useState(false);

  const handleSetup = async () => {
    setIsLoading(true);
    try {
      await setupInitialData();
      // Toast is handled in setupInitialData
    } catch (error) {
      console.error('Setup error:', error);
      // Toast is handled in setupInitialData
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="p-6 bg-white rounded-xl shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-50 rounded-lg">
            <Database className="w-5 h-5 text-blue-500" />
          </div>
          <h2 className="text-lg font-semibold text-gray-900">Database Setup</h2>
        </div>
        <button
          onClick={handleSetup}
          disabled={isLoading}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg text-white transition-colors ${
            isLoading ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-500 hover:bg-blue-600'
          }`}
        >
          {isLoading ? (
            <RefreshCw className="w-4 h-4 animate-spin" />
          ) : (
            <Database className="w-4 h-4" />
          )}
          {isLoading ? 'Setting Up...' : 'Populate Database'}
        </button>
      </div>
      
      <div className="space-y-2 text-sm text-gray-600">
        <p>This will create:</p>
        <ul className="list-disc list-inside space-y-1">
          <li>Initial admin and editor users</li>
          <li>Miner specifications database</li>
          <li>Facility locations database with editor permissions</li>
        </ul>
        <p className="mt-4 text-amber-600">
          Note: This action is safe to run multiple times - it will not create duplicates.
        </p>
      </div>
    </div>
  );
}